angular.module('account', [
  'account.my-articles',
  'account.add-article',
  'account.add-article-live',
  'account.edit-article',
  'account.edit-article-live',
  'account.add-video',
  'account.index',
  'account.settings',
  'account.verification',
  'account.main-page',
  'account.tags',
  'account.roles',
  //'account.sports'
]);



// WEBPACK FOOTER //
// ./client/src/app/account/index.js